/**
 * Redirect ke Auth Landing (pola Hub / panduan SSO).
 * Guard sekali agar banyak request 401 paralel tidak spam navigasi.
 */
let redirectingToAuth = false;

export function redirectToAuth(): void {
  if (redirectingToAuth || typeof window === 'undefined') return;

  const authBase = import.meta.env.VITE_AUTH?.replace(/\/$/, '');
  if (!authBase) return;

  redirectingToAuth = true;
  window.location.replace(`${authBase}/?origin=${encodeURIComponent(window.location.origin)}`);
}
